import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { Device, from, until } from '@helpers/media';
import { contentStyles, paragraphLarge, paragraphRegular } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.blockquote `
  border-left: 2px solid ${brand.secondary.red};
  color: var(--fgColour);
  padding: 0 0 0 ${fluid(20, 148)};

  @media ${from(Device.TabletLarge)} {
    height: 100%;
    padding-bottom: ${fluid(60, 105)};
  }
`;
const Quote = styled.div `
  ${contentStyles};

  p {
    ${paragraphLarge};
  }
`;
const Accrediation = styled.div `
  ${paragraphRegular};

  margin: ${fluid(30, 42)} 0 0;

  @media ${until(Device.Tablet)} {
    > span {
      display: block;

      &:nth-child(2) {
        margin: 6px 0 0;
      }
    }
  }

  @media ${from(Device.Tablet)} {
    /* Add pipe and spacing between spans if more than one exists */
    > span:nth-child(2)::before {
      content: '\\00A0\\007C\\00A0';
    }
  }
`;
const TestimonialCardStyles = {
    Container,
    Quote,
    Accrediation,
};
export default TestimonialCardStyles;
